import React, { useEffect, useState } from 'react';
import { PieChart } from '@mui/x-charts/PieChart';
import { FaSpotify } from 'react-icons/fa';
import { BASE_URL } from '../../controllers/dataController';

const PieChartComponent = ({ applicationData }) => {
    const [piechartdata, setPieChartData] = useState([]);

    useEffect(() => {
        if (!applicationData || !applicationData.piechartdata) {
            setPieChartData([]); // Explicitly clear data
            return;
        }

        const tempdata = []
        Object.entries(applicationData.piechartdata).forEach(([key, value]) => {
            tempdata.push(
                {
                    "id": key,
                    "value": value,
                    "label": key
                }
            )
        });

        setPieChartData(tempdata);
    }, [applicationData]);

    if (piechartdata.length === 0) {
        return <div className="bg-gradient-card border border-border/50 rounded-md p-4">Loading...</div>;
    }

    return (
        <div className="bg-gradient-card border border-border/50 rounded-md p-4">
            <h3 className="text-lg font-semibold mb-4">
                <FaSpotify className="inline-block mr-2 text-green-500" /> Platform Distribution
            </h3>
            <div className='flex items-center justify-around flex-wrap gap-y-3  gap-x-9'>
                {(applicationData && applicationData.platforms !== undefined) ? applicationData.platforms.map(function (object, i) {
                    const label = object["label"];
                    const iconPath = BASE_URL+object["icon"];
                    return <div key={label} className="bg-card-foreground p-2 border border-border/50 rounded-md mb-2 flex items-center">
                        <span className="inline-block w-5 h-5 rounded-full mr-2">
                            <img src={iconPath} ></img>
                        </span>
                        <p className="text-sm text-primary-foreground">{label}</p>
                        <p className="text-sm text-primary-foreground">{applicationData.piechartdata[label] ? "(" + applicationData.piechartdata[label] + ")" : ""}</p>
                    </div>;
                }
                ) : ""}
            </div>

            <div className=" rounded-md flex items-center justify-center text-gray-400">
                <PieChart
                    series={[
                        {
                            data: piechartdata,
                        },
                    ]}
                    sx={{
                        '.MuiChartsLabel-root': {
                            fill: '#FFFFFF', // Label color
                        },
                        '.MuiChartsArcLabel-root': {
                            fill: '#FFFFFF', // Arc label color
                        },
                        '.MuiChartsLegend-label': {
                            fill: '#FFFFFF', // Legend label color (though legend is hidden)
                        },
                    }}
                    width={200}
                    height={200}
                    hideLegend={true}
                />
            </div>
        </div>
    );
};

export default PieChartComponent;
